module.exports = __webpack_public_path__ + "static/media/qa.6e7d8d78.svg";